import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/5be276c0-9b04-4198-977f-096581c9feb9";
export const REGISTER_URL = "https://a.ntrk2.com/f668ba87-cfbb-4255-ac26-b47dfb060f92";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://cashpk.kzw2a.com/download?openExternalBrowser=1&id=5ts7nsfmq9qsq1c";

export * from "./codes";
export * from "./context";
